// cSpell:ignore Afrekening Eindafrekening Gebouw huurcontract Huurder Privaat vertrek
// The kinds of settlement "Add settlement" offers on a unit (design
// 2026-10-16, C; named like the settlement list's Type, Lewis 2026-10-16), in
// the order the modal lists them, the first one chosen:
// - inside a building: "Gebouw" (all costs and provisions of the whole
//   building, made on the building; only for a user who may settle the
//   building's costs), "Privaat" (the unit's own costs and private provision
//   only), then "Eindafrekening bij vertrek" per leaving tenant;
// - on its own: "Afrekening", then the departures.
// Each choice has a title and a small line under it (Lewis, 2026-10-16):
// Gebouw and Privaat explain what they settle, a departure names its tenants
// and the end of their lease ("Hugo Huurder · huurcontract tot 30/06/2026").
// Several departures share their title, so the open menu shows a
// departure's small line too.

import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

export const NEW_SETTLEMENT_BUILDING = "building";
export const NEW_SETTLEMENT_UNIT = "unit";

export interface INewSettlementChoice {
  // NEW_SETTLEMENT_BUILDING, NEW_SETTLEMENT_UNIT or a departing lease's id.
  value: string;
  // The title.
  label: string;
  // The small line under the title: what the choice settles, or for a
  // departure whose lease it is.
  info: string;
  // Also show the small line in the open menu, where it tells choices with
  // the same title apart (the departures).
  infoInMenu: boolean;
}

export const getNewSettlementChoices = (params: {
  // A unit inside a building, not one on its own.
  isInBuilding: boolean;
  canSettleBuilding: boolean;
  // The leases that can get a departure settlement, `until` as shown.
  departures: { id: string; tenantName: string; until: string }[];
}): INewSettlementChoice[] => {
  const { isInBuilding, canSettleBuilding, departures } = params;
  return [
    ...(isInBuilding && canSettleBuilding
      ? [
          {
            value: NEW_SETTLEMENT_BUILDING,
            label: getLocalizedText("settlement.new.choice.building"),
            info: getLocalizedText("settlement.new.choice.building_info"),
            infoInMenu: false,
          },
        ]
      : []),
    isInBuilding
      ? {
          value: NEW_SETTLEMENT_UNIT,
          label: getLocalizedText("settlement.new.choice.private"),
          info: getLocalizedText("settlement.new.choice.private_info"),
          infoInMenu: false,
        }
      : {
          value: NEW_SETTLEMENT_UNIT,
          label: getLocalizedText("settlement.departure.choose_regular"),
          info: getLocalizedText("settlement.departure.choose_regular_info"),
          infoInMenu: false,
        },
    ...departures.map(departure => ({
      value: departure.id,
      label: getLocalizedText("settlement.title.departure"),
      info: getLocalizedText("settlement.new.choice.departure_info", {
        tenant: departure.tenantName,
        until: departure.until,
      }),
      infoInMenu: true,
    })),
  ];
};
